import { render, staticRenderFns } from "./Volume.vue?vue&type=template&id=6ba4d8df&scoped=true"
import script from "./Volume.vue?vue&type=script&lang=js"
export * from "./Volume.vue?vue&type=script&lang=js"
import style0 from "./Volume.vue?vue&type=style&index=0&id=6ba4d8df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba4d8df",
  null
  
)

export default component.exports